import SlideoverModal from "src/components/SlideoverModal";
import { RootState } from "src/stores";
import { connect } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { queryQueueProps } from "src/interfaces";
import Lucide from "src/base-components/Lucide";
import LoadingIcon from "src/base-components/LoadingIcon";
import { checkPermission, dateParser, isAdmin, isManager } from "src/helpers";
import _ from "lodash";
import { clearAllListeners } from "@reduxjs/toolkit";
import Card from "src/components/Card";
import Button from "src/base-components/Button";
import { fetchTicketQueues, updateTicketQueue } from "src/stores/ticketQueue";
import { updateQueue } from "src/stores/queue";
import { queryAPIUrls } from "src/common/apiActions";
import { queryAssignToTicketing } from "src/stores/query";

interface ComponentProps {
  visible: boolean;
  setVisible: (payload: boolean) => void;
  fetchData: (params?: { page?: number; limit?: number }) => void;

  onUpdate: (payload: {
    id: string;
    query_id: string;
    user_id: number;
    callback?: Function;
  }) => void;
  assignToTicketing: (payload: {
    id: string;
    query_id: string;
    user_id: number;
    callback?: Function;
  }) => void;
  ticketQueues: {
    items: queryQueueProps[] | undefined;
    page: number;
    hasMore: boolean;
  };
  token: any;
}

function Component(props: ComponentProps) {
  const {
    ticketQueues,
    fetchData,
    setVisible,
    visible,
    onUpdate,
    token,
    assignToTicketing,
  } = props;
  const navigate = useNavigate();
  const [loadingMore, setLoadingMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoadedAll, setIsLoadedAll] = useState(false);

  const loadData = useCallback(
    (page?: number) => {
      if (checkPermission(queryAPIUrls?.viewAmadeusQueue)) {
        fetchData({ page, limit: 10 });
      }
    },
    [fetchData]
  );

  const handleScroll = (event: any) => {
    const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
    const distanceFromBottom = scrollHeight - scrollTop - clientHeight;

    if (distanceFromBottom <= 0 && ticketQueues.hasMore && !loadingMore) {
      setLoadingMore(true);
      fetchData({ page: ticketQueues.page + 1, limit: 10 });
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    loadData(1);
    const handleFocus = () => {
      if (props?.token && localStorage.getItem("deviceToken")) {
        loadData(1);
      }
    };
    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("focus", handleFocus);
      clearAllListeners();
    };
  }, [loadData, props.token]);

  return (
    <>
      <SlideoverModal
        className="p-2"
        visible={visible}
        onClose={() => setVisible(false)}
        handleScroll={handleScroll}
        headerTitle="Queries waiting for ticketing"
      >
        {loading ? (
          <div className="flex w-[100%] justify-center py-16">
            <LoadingIcon
              color="#64748b"
              icon="oval"
              className="w-8 h-8 mx-auto"
            />
          </div>
        ) : ticketQueues?.items?.length == 0 ? (
          <div className="flex w-[100%] justify-center py-28">No Queries</div>
        ) : (
          <div
            onScroll={(event) => {
              const { scrollTop, scrollHeight, clientHeight } =
                event?.currentTarget;
              const distanceFromBottom =
                scrollHeight - scrollTop - clientHeight;
              if (distanceFromBottom == 0 && !isLoadedAll) {
                if (!loadingMore && !loading) {
                  setLoadingMore(true);
                  // loadData(true);
                }
              } else if (distanceFromBottom > 0) {
                setIsLoadedAll(false);
              }
            }}
            className="flex flex-col gap-0.5"
          ></div>
        )}
        <div onScroll={handleScroll} className="flex flex-col gap-2">
          {!_.isEmpty(ticketQueues?.items) &&
            ticketQueues?.items?.map((item: any, itemKey) => (
              <Card key={itemKey}>
                <div>
                  <div className="flex justify-between">
                    <div className="flex items-center text-[#075985] ">
                      {item?.query_no}
                    </div>
                    <div className="text-[12px] text-right">
                      {dateParser(item.updated_at, "DD-MM-YYYY")}
                    </div>
                  </div>
                  <div className="flex justify-between">
                    <div className="flex flex-col my-2">
                      <div className="text-[12px]">
                        {item?.querie?.customer?.fullname}
                      </div>
                      <div
                        className="text-[10px]"
                        style={{ lineHeight: "1rem" }}
                      >
                        Customer ID: {item?.querie?.customer?.customer_id || ""}
                      </div>
                    </div>
                    <div className="flex flex-col leading-4 my-1">
                      <div className="text-[10px] font-medium text-[#075985] text-end ">
                        Payment/Billing Amount:
                      </div>
                      <div className="text-[12px] text-left">
                        ${item?.querie?.payment[0]?.amount}
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-row justify-between mb-1">
                    <div className="flex flex-col leading-4 my-1 w-full">
                      {/* <div className="text-[10px] font-medium text-[#075985] text-start ">
                        Assigned by:
                      </div>
                      <div className="text-[12px] text-left">
                        {item?.assigned_by_user?.name}
                      </div> */}
                    </div>
                    <Button
                      variant="outline-primary"
                      className=" font-bold w-32"
                      onClick={() => {
                        if (!item?.assigned_to_user) {
                          assignToTicketing({
                            id: item?.id,
                            query_id: item?.query_id,
                            user_id: token?.id,
                          });
                        }
                        onUpdate({
                          id: item?.id,
                          query_id: item?.query_id,
                          user_id: token?.id,
                        });

                        props?.setVisible(false);
                        if (
                          location?.pathname !=
                            `/query-detail/${item?.query_id}` ||
                          location?.pathname !=
                            `/amadeus-query-detail/${item?.query_id}`
                        ) {
                          if (item.querie.query_category == "from_amadeus") {
                            navigate(`/amadeus-query-detail/${item?.query_id}`);
                          } else {
                            navigate(`/query-detail/${item?.query_id}`);
                          }
                        }
                      }}
                    >
                      Proceed
                      <Lucide icon="ArrowRight" className="w-4 h-4 ml-2" />
                    </Button>
                  </div>
                </div>
              </Card>
            ))}
          {loadingMore && (
            <div className="flex justify-center py-2">
              <LoadingIcon color="#64748b" icon="oval" className="w-6 h-6" />
            </div>
          )}
        </div>
      </SlideoverModal>
    </>
  );
}

const mapStateToProps = ({ queries, authUser, ticketQueues }: RootState) => ({
  token: authUser,
  ticketQueues: ticketQueues,
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchData: (params?: { page?: number; limit?: number }) =>
    dispatch(fetchTicketQueues(params)),
  onUpdate: (payload: any) => dispatch(updateTicketQueue(payload)),
  assignToTicketing: (payload: any) =>
    dispatch(queryAssignToTicketing(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Component);
